import { useState, useEffect } from 'react';
import Btn from '../ui/Btn';
import Panel from '../ui/Panel';
import MatchDetail from '../cs/MatchDetail';
import { Crest } from '../cs/MatchDetail';
import { M_TEAMS, M_LEADERS, LIVE_MATCH, UPCOMING_MATCHES, RESULT_MATCHES } from '../data/matchData';
import { useAppStore } from '../store';

/* ---- Flag (inline, not worth a separate file) ---- */
function Flag({ c, w = 17 }) {
  const h = Math.round(w * 0.66);
  if (c === 'ru') {
    return <span style={{ display: 'inline-block', width: w, height: h, borderRadius: 2, overflow: 'hidden',
      border: '1px solid rgba(255,255,255,0.18)', flexShrink: 0,
      background: 'linear-gradient(#fff 0 33.3%, #0039A6 33.3% 66.6%, #D52B1E 66.6% 100%)' }} />;
  }
  return (
    <span style={{ position: 'relative', display: 'inline-block', width: w, height: h, borderRadius: 2,
      overflow: 'hidden', border: '1px solid rgba(255,255,255,0.18)', flexShrink: 0, background: '#00AFCA' }}>
      <span style={{ position: 'absolute', top: '50%', left: '52%', width: h * 0.42, height: h * 0.42,
        transform: 'translate(-50%,-50%)', borderRadius: '50%', background: '#FFD24A' }} />
      <span style={{ position: 'absolute', left: 2, top: 1, bottom: 1, width: 2.5, background: '#FFD24A', borderRadius: 2 }} />
    </span>
  );
}

const FILTERS = [
  { k: 'all', label: 'Все' },
  { k: 'live', label: 'LIVE' },
  { k: 'upcoming', label: 'Предстоящие' },
  { k: 'finished', label: 'Результаты' },
];

export default function MatchesPage() {
  const { go } = useAppStore();
  const motion = 1;
  const [filter, setFilter] = useState('all');
  const [detail, setDetail] = useState(null);

  const showLive = filter === 'all' || filter === 'live';
  const showUp = filter === 'all' || filter === 'upcoming';
  const showFin = filter === 'all' || filter === 'finished';
  const counts = { live: 1, upcoming: UPCOMING_MATCHES.length, finished: RESULT_MATCHES.length };

  return (
    <div className="page-in" style={{ position: 'relative', zIndex: 1, paddingTop: 40, paddingBottom: 40 }}>
      <div className="container-wide">

        {/* header */}
        <div className="row" style={{ alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: 18, marginBottom: 26 }}>
          <div className="col gap-2">
            <div className="eyebrow row gap-2" style={{ alignItems: 'center' }}>
              <span style={{ width: 18, height: 2, background: 'var(--accent)' }} />
              МАТЧ-ЦЕНТР · CS2 OPEN · СКО
            </div>
            <h1 className="display" style={{ margin: 0, fontSize: 'clamp(36px,6vw,64px)', lineHeight: 0.92 }}>
              <span className="grad-text">МАТЧИ</span>{' '}
              <span style={{ color: 'var(--accent)' }}>/</span>{' '}
              <span className="grad-red">LIVE</span>
            </h1>
            <p className="muted" style={{ margin: 0, fontSize: 14, maxWidth: 560 }}>
              Прямые трансляции, счёт по картам, полная статистика игроков и история раундов — как на больших турнирах.
            </p>
          </div>
          <span className="row gap-2" style={{ alignItems: 'center', padding: '8px 13px', borderRadius: 'var(--r-sm)',
            background: 'rgba(225,18,23,0.12)', border: '1px solid var(--line-accent)' }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--accent-bright)',
              boxShadow: '0 0 10px var(--accent)', animation: 'c4blink 1s steps(1) infinite' }} />
            <span className="mono" style={{ fontSize: 12, color: 'var(--accent-bright)', fontWeight: 700, letterSpacing: '0.1em' }}>1 МАТЧ В ЭФИРЕ</span>
          </span>
        </div>

        {/* filter tabs */}
        <div className="row" style={{ gap: 8, marginBottom: 26, flexWrap: 'wrap' }}>
          {FILTERS.map(f => {
            const active = filter === f.k;
            const cnt = f.k === 'all' ? null : counts[f.k];
            const isLive = f.k === 'live';
            return (
              <button key={f.k} onClick={() => setFilter(f.k)} style={{
                position: 'relative', display: 'inline-flex', alignItems: 'center', gap: 8,
                height: 40, padding: '0 18px', cursor: 'pointer',
                fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.04em',
                color: active ? '#fff' : 'var(--fg-muted)',
                background: active ? 'linear-gradient(120deg, var(--accent-bright), var(--accent) 60%, var(--accent-deep))' : 'var(--surface-2)',
                border: `1px solid ${active ? 'transparent' : 'var(--line)'}`,
                clipPath: 'polygon(8px 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%, 0 8px)',
                boxShadow: active ? '0 8px 24px -10px var(--accent-glow)' : 'none', transition: 'color .2s, background .2s',
              }}>
                {isLive && <span style={{ width: 7, height: 7, borderRadius: '50%',
                  background: active ? '#fff' : 'var(--accent-bright)',
                  boxShadow: `0 0 8px ${active ? '#fff' : 'var(--accent)'}`,
                  animation: 'c4blink 1s steps(1) infinite' }} />}
                {f.label}
                {cnt != null && <span className="mono" style={{ fontSize: 11, padding: '1px 6px', borderRadius: 4,
                  background: active ? 'rgba(0,0,0,0.25)' : 'var(--surface-3)',
                  color: active ? '#fff' : 'var(--fg-muted)' }}>{cnt}</span>}
              </button>
            );
          })}
        </div>

        {/* layout */}
        <div className="matches-grid" style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) 320px', gap: 26, alignItems: 'start' }}>
          {/* main */}
          <div className="col" style={{ gap: 26 }}>
            {showLive && <LiveHero match={LIVE_MATCH} motion={motion} onOpen={() => setDetail(LIVE_MATCH)} />}

            {showUp && (
              <section>
                <ListHeader title="Предстоящие матчи" sub="Расписание плей-офф" icon="calendar" />
                <div className="col" style={{ gap: 10, marginTop: 14 }}>
                  {UPCOMING_MATCHES.map((m, i) => <MatchRow key={m.id} match={m} index={i} motion={motion} onOpen={() => setDetail(m)} />)}
                </div>
              </section>
            )}

            {showFin && (
              <section>
                <ListHeader title="Результаты" sub="Сыгранные матчи турнира" icon="check" />
                <div className="col" style={{ gap: 10, marginTop: 14 }}>
                  {RESULT_MATCHES.map((m, i) => <MatchRow key={m.id} match={m} index={i} motion={motion} onOpen={() => setDetail(m)} />)}
                </div>
              </section>
            )}
          </div>

          {/* aside */}
          <aside className="matches-aside col" style={{ gap: 20, position: 'sticky', top: 92 }}>
            <Leaderboard motion={motion} />
            <EventCard go={go} />
          </aside>
        </div>
      </div>

      {detail && <MatchDetail match={detail} onClose={() => setDetail(null)} motion={motion} />}
    </div>
  );
}

/* ---- Live hero ---- */
function LiveHero({ match, motion, onOpen }) {
  const A = M_TEAMS[match.A], B = M_TEAMS[match.B];
  const liveMap = match.maps.find(m => m.status === 'live');
  const [spec, setSpec] = useState(match.spectators);
  useEffect(() => {
    const id = setInterval(() => setSpec(s => s + Math.floor(Math.random() * 9) - 3), 2200);
    return () => clearInterval(id);
  }, []);

  return (
    <div onClick={onOpen} className="live-hero" style={{
      position: 'relative', overflow: 'hidden', cursor: 'pointer', borderRadius: 'var(--r-lg)',
      background: `linear-gradient(120deg, ${A.color}1c, transparent 40%, ${B.color}1c), linear-gradient(160deg, var(--surface-2), var(--surface))`,
      border: '1px solid var(--line-accent)', boxShadow: 'var(--shadow-card), var(--glow-red)',
    }}>
      {/* scan sweep */}
      <div style={{ position: 'absolute', top: 0, bottom: 0, width: '40%', pointerEvents: 'none',
        background: 'linear-gradient(100deg, transparent, rgba(255,255,255,0.05), transparent)',
        animation: `scanSweep ${6 / motion}s linear infinite` }} />

      {/* top strip */}
      <div className="row" style={{ alignItems: 'center', justifyContent: 'space-between', padding: '13px 20px',
        borderBottom: '1px solid var(--line)', position: 'relative', zIndex: 1, flexWrap: 'wrap', gap: 10 }}>
        <div className="row gap-3" style={{ alignItems: 'center', flexWrap: 'wrap' }}>
          <span className="row gap-2" style={{ alignItems: 'center', padding: '5px 11px', borderRadius: 'var(--r-sm)',
            background: 'rgba(225,18,23,0.16)', border: '1px solid var(--line-accent)' }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--accent-bright)',
              boxShadow: '0 0 10px var(--accent)', animation: 'c4blink 1s steps(1) infinite' }} />
            <span className="mono" style={{ fontSize: 10.5, letterSpacing: '0.16em', color: 'var(--accent-bright)', fontWeight: 700 }}>LIVE</span>
          </span>
          <span className="mono" style={{ fontSize: 11, color: 'var(--fg-muted)', letterSpacing: '0.1em' }}>{match.stage} · BO{match.bo}</span>
          <span className="row gap-1">
            {Array.from({ length: match.stars }).map((_, i) => (
              <svg key={i} width="12" height="12" viewBox="0 0 24 24" fill="var(--gold)"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z" /></svg>
            ))}
          </span>
        </div>
        <span className="row gap-2" style={{ alignItems: 'center', color: 'var(--fg-muted)' }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
          <span className="mono" style={{ fontSize: 12 }}>{spec.toLocaleString('ru-RU')}</span>
        </span>
      </div>

      {/* body */}
      <div style={{ position: 'relative', zIndex: 1, padding: 'clamp(20px,3vw,30px) clamp(16px,3vw,30px)' }}>
        <div className="row" style={{ alignItems: 'center', justifyContent: 'center', gap: 'clamp(14px,4vw,44px)' }}>
          <HeroTeam tag={match.A} align="right" leading={match.mapsWon.A > match.mapsWon.B} />
          <div className="col" style={{ alignItems: 'center', gap: 6, minWidth: 120 }}>
            <span className="mono" style={{ fontSize: 10, letterSpacing: '0.16em', color: 'var(--fg-muted)' }}>СЧЁТ ПО КАРТАМ</span>
            <div className="row" style={{ alignItems: 'center', gap: 'clamp(10px,2vw,18px)' }}>
              <span className="display" style={{ fontSize: 'clamp(44px,8vw,72px)', lineHeight: 1, color: match.mapsWon.A >= match.mapsWon.B ? 'var(--fg)' : 'var(--fg-muted)', textShadow: '0 0 24px rgba(0,0,0,0.5)' }}>{match.mapsWon.A}</span>
              <span className="display" style={{ fontSize: 'clamp(28px,5vw,44px)', color: 'var(--accent)' }}>:</span>
              <span className="display" style={{ fontSize: 'clamp(44px,8vw,72px)', lineHeight: 1, color: match.mapsWon.B >= match.mapsWon.A ? 'var(--fg)' : 'var(--fg-muted)', textShadow: '0 0 24px rgba(0,0,0,0.5)' }}>{match.mapsWon.B}</span>
            </div>
            {liveMap && (
              <span className="row gap-2" style={{ alignItems: 'center', marginTop: 2, padding: '5px 11px', borderRadius: 'var(--r-sm)',
                background: 'var(--bg-deep)', border: '1px solid var(--line-accent)' }}>
                <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--accent-bright)', animation: 'c4blink 1s steps(1) infinite' }} />
                <span className="mono" style={{ fontSize: 11, color: 'var(--accent-bright)', fontWeight: 700 }}>{liveMap.name}</span>
                <span className="mono" style={{ fontSize: 12, color: 'var(--fg)', fontWeight: 700 }}>{liveMap.a} : {liveMap.b}</span>
              </span>
            )}
          </div>
          <HeroTeam tag={match.B} align="left" leading={match.mapsWon.B > match.mapsWon.A} />
        </div>

        {/* map chips */}
        <div className="row gap-2 wrap" style={{ justifyContent: 'center', marginTop: 24 }}>
          {match.maps.map((m, i) => {
            const live = m.status === 'live', up = m.status === 'upcoming';
            return (
              <span key={i} className="mono" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 12, padding: '7px 13px', borderRadius: 'var(--r-sm)',
                background: live ? 'rgba(225,18,23,0.12)' : 'var(--surface-2)',
                border: `1px solid ${live ? 'var(--line-accent)' : 'var(--line)'}`, opacity: up ? 0.55 : 1 }}>
                <span style={{ color: live ? 'var(--accent-bright)' : 'var(--fg-soft)', fontWeight: 700 }}>{m.name}</span>
                {!up ? <span style={{ color: 'var(--fg)' }}>{m.a}:{m.b}</span> : <span style={{ color: 'var(--fg-faint)' }}>—</span>}
                {live && <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--accent-bright)', animation: 'c4blink 1s steps(1) infinite' }} />}
              </span>
            );
          })}
        </div>

        <div className="center" style={{ marginTop: 24 }}>
          <Btn size="md" onClick={onOpen} icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z" /></svg>}>
            Смотреть матч
          </Btn>
        </div>
      </div>
    </div>
  );
}

function HeroTeam({ tag, align, leading }) {
  const t = M_TEAMS[tag];
  return (
    <div className="row" style={{ alignItems: 'center', gap: 'clamp(8px,2vw,16px)', flexDirection: align === 'right' ? 'row' : 'row-reverse', minWidth: 0 }}>
      <div className="col" style={{ alignItems: align === 'right' ? 'flex-end' : 'flex-start', minWidth: 0 }}>
        <span className="display" style={{ fontSize: 'clamp(16px,2.6vw,28px)', whiteSpace: 'nowrap', color: leading ? 'var(--fg)' : 'var(--fg-soft)' }}>{t.name}</span>
        <span className="mono" style={{ fontSize: 10, color: 'var(--fg-muted)', letterSpacing: '0.08em' }}>{t.tag} · SEED #{t.seed}</span>
      </div>
      <Crest tag={tag} size={64} live={leading} />
    </div>
  );
}

/* ---- Match row ---- */
function MatchRow({ match, index, motion, onOpen }) {
  const fin = match.status === 'finished';
  const aWon = fin && match.mapsWon.A > match.mapsWon.B;
  const bWon = fin && match.mapsWon.B > match.mapsWon.A;
  const [hov, setHov] = useState(false);

  return (
    <div onClick={onOpen} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        position: 'relative', display: 'grid', gridTemplateColumns: '92px minmax(0,1fr) auto',
        gap: 'clamp(8px,2vw,18px)', alignItems: 'center', padding: '14px 18px',
        cursor: 'pointer', borderRadius: 'var(--r-md)', overflow: 'hidden',
        background: hov ? 'var(--surface-2)' : 'var(--surface)',
        border: `1px solid ${hov ? 'var(--line-strong)' : 'var(--line)'}`,
        transform: hov ? 'translateX(3px)' : 'none',
        transition: 'transform .2s var(--ease-out), background .2s, border-color .2s',
        animation: `fadeUp ${0.45 / motion}s var(--ease-out) both`, animationDelay: `${index * 0.06}s`,
      }}>
      <span style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 3, background: 'var(--accent)',
        boxShadow: '0 0 10px var(--accent-glow)', opacity: hov ? 1 : 0, transition: 'opacity .2s' }} />

      {/* time */}
      <div className="col" style={{ gap: 3 }}>
        {fin ? (
          <>
            <span className="mono" style={{ fontSize: 11, color: 'var(--fg-muted)' }}>{match.ago}</span>
            <span className="mono" style={{ fontSize: 9.5, letterSpacing: '0.12em', color: 'var(--fg-faint)' }}>ЗАВЕРШЁН</span>
          </>
        ) : (
          <>
            <span className="display" style={{ fontSize: 15, color: 'var(--gold)' }}>{(match.time || '').split('·')[1] || 'СКОРО'}</span>
            <span className="mono" style={{ fontSize: 9.5, letterSpacing: '0.1em', color: 'var(--fg-faint)' }}>{(match.time || '').split('·')[0]}</span>
          </>
        )}
      </div>

      {/* teams */}
      <div className="col" style={{ gap: 7, minWidth: 0 }}>
        <TeamLine tag={match.A} score={fin ? match.mapsWon.A : null} won={aWon} dim={bWon} />
        <TeamLine tag={match.B} score={fin ? match.mapsWon.B : null} won={bWon} dim={aWon} />
      </div>

      {/* meta */}
      <div className="col match-meta" style={{ gap: 5, alignItems: 'flex-end', textAlign: 'right' }}>
        <span className="row gap-2" style={{ alignItems: 'center' }}>
          <span className="row gap-1">
            {Array.from({ length: match.stars }).map((_, i) => (
              <svg key={i} width="11" height="11" viewBox="0 0 24 24" fill="var(--gold)"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z" /></svg>
            ))}
          </span>
          <span className="mono" style={{ fontSize: 10.5, padding: '2px 7px', borderRadius: 4, background: 'var(--surface-3)', color: 'var(--fg-soft)', fontWeight: 700 }}>BO{match.bo}</span>
        </span>
        <span className="mono" style={{ fontSize: 10.5, color: 'var(--fg-muted)', letterSpacing: '0.06em' }}>{match.stage}</span>
        {fin && match.maps && <span className="mono" style={{ fontSize: 10, color: 'var(--fg-faint)' }}>{match.maps.map(m => m.name).join(' · ')}</span>}
      </div>
    </div>
  );
}

function TeamLine({ tag, score, won, dim }) {
  const t = M_TEAMS[tag];
  return (
    <div className="row" style={{ alignItems: 'center', justifyContent: 'space-between', gap: 10, opacity: dim ? 0.5 : 1 }}>
      <div className="row gap-2" style={{ alignItems: 'center', minWidth: 0, flex: 1 }}>
        <Crest tag={tag} size={28} />
        <span className="display" style={{ fontSize: 16, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: won ? 'var(--fg)' : 'var(--fg-soft)' }}>{t.name}</span>
        {won && <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--gold)" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><path d="M20 6L9 17l-5-5" /></svg>}
      </div>
      {score != null && <span className="display" style={{ fontSize: 18, color: won ? 'var(--gold)' : 'var(--fg-muted)', minWidth: 18, textAlign: 'center' }}>{score}</span>}
    </div>
  );
}

/* ---- Section header ---- */
function ListHeader({ title, sub, icon }) {
  const icons = {
    calendar: <path d="M3 9h18M7 3v4M17 3v4M5 5h14a1 1 0 011 1v14a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1z" />,
    check: <path d="M9 11l3 3L22 4M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />,
  };
  return (
    <div className="row gap-3" style={{ alignItems: 'center' }}>
      <span className="center" style={{ width: 34, height: 34, borderRadius: 8, background: 'var(--surface-2)', border: '1px solid var(--line)', color: 'var(--accent)' }}>
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{icons[icon]}</svg>
      </span>
      <div className="col">
        <span className="display" style={{ fontSize: 21 }}>{title}</span>
        <span className="mono" style={{ fontSize: 10.5, color: 'var(--fg-muted)', letterSpacing: '0.06em' }}>{sub}</span>
      </div>
    </div>
  );
}

/* ---- Leaderboard ---- */
function Leaderboard({ motion }) {
  return (
    <Panel pad={0} style={{ overflow: 'hidden' }}>
      <div className="row gap-2" style={{ alignItems: 'center', padding: '15px 18px', borderBottom: '1px solid var(--line)',
        background: 'linear-gradient(90deg, rgba(230,183,60,0.10), transparent)' }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="var(--gold)"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z" /></svg>
        <span className="display" style={{ fontSize: 16 }}>Лидеры рейтинга</span>
        <span className="grow" />
        <span className="mono" style={{ fontSize: 9.5, color: 'var(--fg-faint)', letterSpacing: '0.1em' }}>RATING 2.0</span>
      </div>
      {M_LEADERS.map((p, i) => {
        const t = M_TEAMS[p.team];
        return (
          <div key={p.nick} className="row" style={{ alignItems: 'center', gap: 11, padding: '11px 18px',
            borderBottom: i < M_LEADERS.length - 1 ? '1px solid var(--line)' : 'none',
            animation: `fadeUp ${0.4 / motion}s var(--ease-out) both`, animationDelay: `${i * 0.05}s` }}>
            <span className="display" style={{ fontSize: 15, width: 18, color: i === 0 ? 'var(--gold)' : 'var(--fg-faint)' }}>{i + 1}</span>
            <div className="center" style={{ width: 30, height: 30, borderRadius: 6, flexShrink: 0,
              fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 11,
              background: `linear-gradient(140deg, ${t.color}55, var(--surface-3))`,
              border: '1px solid var(--line)', color: '#fff' }}>{p.nick.slice(0, 2).toUpperCase()}</div>
            <div className="col" style={{ minWidth: 0, flex: 1 }}>
              <span className="row gap-1" style={{ alignItems: 'center' }}>
                <Flag c={p.c} w={14} />
                <span style={{ fontWeight: 700, fontSize: 13.5 }}>{p.nick}</span>
              </span>
              <span className="mono" style={{ fontSize: 10, color: 'var(--fg-muted)' }}>{t.tag} · {p.maps} карт · K/D {p.kd}</span>
            </div>
            <span className="mono" style={{ fontSize: 14, fontWeight: 700,
              color: p.rating >= 1.15 ? '#4ADE80' : p.rating >= 1.0 ? '#9FE08A' : 'var(--gold)' }}>{p.rating.toFixed(2)}</span>
          </div>
        );
      })}
    </Panel>
  );
}

/* ---- Event card ---- */
function EventCard({ go }) {
  return (
    <Panel accent pad={20}>
      <div className="eyebrow" style={{ marginBottom: 12 }}>Текущий ивент</div>
      <div className="display" style={{ fontSize: 22, lineHeight: 1.05 }}>CS2 OPEN · СКО</div>
      <div className="mono" style={{ fontSize: 11, color: 'var(--fg-muted)', marginTop: 6, letterSpacing: '0.06em' }}>SINGLE ELIM · 8 КОМАНД · ПЕТРОПАВЛОВСК</div>
      <div className="col gap-2" style={{ marginTop: 16 }}>
        {[['Стадия', '1/2 финала'], ['Команд осталось', '4'], ['Призовой', '200 000 ₸']].map(([l, v], i) => (
          <div key={i} className="row" style={{ justifyContent: 'space-between', alignItems: 'center', paddingBottom: 8, borderBottom: i < 2 ? '1px solid var(--line)' : 'none' }}>
            <span className="mono" style={{ fontSize: 11, color: 'var(--fg-muted)', letterSpacing: '0.06em' }}>{l}</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: i === 2 ? 'var(--gold)' : 'var(--fg)' }}>{v}</span>
          </div>
        ))}
      </div>
      <button onClick={() => go('register')} style={{ width: '100%', marginTop: 16, height: 42, cursor: 'pointer',
        fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.05em',
        color: 'var(--accent-bright)', background: 'transparent', border: '1.5px solid var(--line-accent)', borderRadius: 'var(--r-sm)' }}>
        Заявиться на турнир →
      </button>
    </Panel>
  );
}
